import { abschlussWeg } from './zustandLabel';

// Die Warnung beim Verlassen einer fertigen Bestellung (02.11.2026).
//
// DER FALL, aus dem Laden: Am PC wird die Rechnung in BONUS geschrieben,
// weil alle Titel da sind — und danach vergisst man, die Bestellung im
// Tracking abzuschließen. Sie bleibt auf „Eingetroffen" stehen, oft
// tagelang. Das Tracking kann BONUS nicht sehen; aber es kann den
// Moment erkennen, in dem jemand eine fertige Bestellung verlässt, und
// einmal nachfragen.
//
// WANN SIE FÄLLIG IST — alle vier zugleich:
//   1. am PC (zeigerFein): dort wird die Rechnung geschrieben. Am
//      Tablet im Wareneingang wäre sie nur im Weg.
//   2. alles ist da: jede wirksame Position vollständig eingetroffen.
//   3. der nächste Schritt steht noch aus: bei Versand ist die Bestellung
//      nicht im Endzustand; bei Abholung ist sie noch nicht abholbereit
//      (und nicht im Endzustand).
//   4. kein Shopify: dort schließt der Webhook ab (E47).
//
// EINMAL JE BESTELLUNG UND SITZUNG. Wer „Später" sagt, hat entschieden;
// die zweite Frage wäre Gängelei. Gemerkt wird das im sessionStorage
// (nur eine Bestellnummer, keine sensiblen Daten).

export type VerlassenWarnungArt = 'versand' | 'abholung';

type Position = { menge_wirksam: number; menge_eingegangen: number };
type BestellungFuerWarnung = {
  bestellnr: string;
  shopify_order_id: string | null;
  versandart: { code: string } | null;
  zustand: { code: string; ist_endzustand: boolean };
  positionen: Position[];
};

export function allesEingegangen(positionen: readonly Position[]): boolean {
  const wirksame = positionen.filter((p) => p.menge_wirksam > 0);
  return wirksame.length > 0 && wirksame.every((p) => p.menge_eingegangen >= p.menge_wirksam);
}

export function verlassenWarnungArt(
  b: BestellungFuerWarnung | undefined,
  zeigerFein: boolean
): VerlassenWarnungArt | null {
  if (!b || !zeigerFein) return null;
  if (b.zustand.ist_endzustand) return null;
  if (!allesEingegangen(b.positionen)) return null;
  const weg = abschlussWeg(b);
  if (weg === 'versand') return 'versand';
  if (weg === 'abholung' && b.zustand.code !== 'bereit') return 'abholung';
  return null;
}

const SCHLUESSEL = 'verlassen-warnung:';

export function verlassenWarnungSchonGezeigt(bestellnr: string): boolean {
  try {
    return sessionStorage.getItem(SCHLUESSEL + bestellnr) !== null;
  } catch {
    return false;
  }
}

export function verlassenWarnungMerken(bestellnr: string): void {
  try {
    sessionStorage.setItem(SCHLUESSEL + bestellnr, '1');
  } catch {
    // Ohne Speicher wird höchstens einmal mehr gefragt.
  }
}
